/**
 * SA-1079: the triage view is oldest first by design, so an item that
 * arrives during a demo lands at the bottom, off screen. The view is
 * replaced whole on every silent refetch (an inbox event, the 30 s poll),
 * so a new item is already in it; this is the bookkeeping over that
 * replace, pure. Since SA-1092 the triage view is the queue: the store keeps
 * the result as `queue.arrivedIds` and `QueueList` draws the pill (SA-1104
 * removed the conversation list's own).
 */

/** The ids the fresh list holds that the previous one did not, plus the
 * earlier arrivals the fresh list still holds. Each id once. */
export function arrivedIds(previous: readonly string[], fresh: readonly string[], arrived: readonly string[]): string[] {
  const before = new Set(previous)
  const now = new Set(fresh)
  const out: string[] = []
  const held = new Set<string>()
  for (const id of arrived) {
    if (now.has(id) && !held.has(id)) { out.push(id); held.add(id) }
  }
  for (const id of fresh) {
    if (!before.has(id) && !held.has(id)) { out.push(id); held.add(id) }
  }
  return out
}
